<template>
  <div class="premDiv">
    <div id="modalContainer" v-if="this.$store.state.sceneElementCurrentPopup != -1">
      <button id="closePopup" @click="activePopup(-1)" >&times;</button>
      <div id="customModal">
      <div id="selectorContainer">
        <button @click="activePopup(0)" :class="this.$store.state.sceneElementCurrentPopup == 0 ? 'active':'' ">Characters</button>
        <button @click="activePopup(1)" :class="this.$store.state.sceneElementCurrentPopup == 1 ? 'active':'' ">Models</button>
        <button @click="activePopup(5)" :class="this.$store.state.sceneElementCurrentPopup == 5 ? 'active':'' ">Effects</button>
        <button @click="activePopup(6)" :class="this.$store.state.sceneElementCurrentPopup == 6 ? 'active':'' ">Lights</button>
        <button @click="activePopup(2)" :class="this.$store.state.sceneElementCurrentPopup == 2 ? 'active':'' ">Sounds</button>
        <button @click="activePopup(3)" :class="this.$store.state.sceneElementCurrentPopup == 3 ? 'active':'' ">Videos</button>
        <button @click="activePopup(4)" :class="this.$store.state.sceneElementCurrentPopup == 4 ? 'active':'' ">Images</button>
      </div>
      <div v-if="this.$store.state.sceneElementCurrentPopup == 1" ><models @closePopup="activePopup(-1)" /></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 0"><character @closePopup="activePopup(-1)"/></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 2"><sounds @closePopup="activePopup(-1)"/></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 3"><Video @closePopup="activePopup(-1)"/></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 4"><mediaImages @closePopup="activePopup(-1)"/></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 5"><effect @closePopup="activePopup(-1)"/></div>
      <div v-else-if="this.$store.state.sceneElementCurrentPopup == 6"><light @closePopup="activePopup(-1)"/></div>
      <div v-else></div>
    </div>
    </div>
    <div id="mask" v-if="this.$store.state.sceneElementCurrentPopup != -1"></div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3">
          
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li><span class="dropdown-item" @click="showComponent('modelsinspector', 1)">3D Model</span></li>
            <li><span class="dropdown-item" @click="showComponent('characterinspector', 2)">Character Model</span></li>
            <li><span class="dropdown-item" @click="showComponent('lightsinspector', 0)">Lights</span></li>
            <li>
              <a class="dropdown-item" href="#"> Media </a>
              <ul class="dropdown-menu dropdown-submenu">
                <li>
                  <span
                    class="dropdown-item"
                    @click="showComponent('soundinspector')"
                    >Sound</span
                  >
                </li>
                <li>
                  <span
                    class="dropdown-item"
                    @click="showComponent('videosinspector')"
                    >Videos</span
                  >
                </li>
                <li>
                 <span class="dropdown-item" @click="showComponent('imagesinspector')">Images</span>
                </li>
    <!--                <li>-->
    <!--                  <span class="dropdown-item" @click="showComponent('videosinspector')">Videos</span>-->
    <!--                </li>-->
                  </ul>
                </li>
                <!-- <li>
                    <span class="dropdown-item" @click="showComponent('effectsinspector')">Effects</span>
                </li> -->
    <!--            <li>-->
    <!--                          <span class="dropdown-item" @click="showComponent('experience')"-->
    <!--                          >Experience</span-->
    <!--                          >-->
    <!--            </li>-->
    <!--            <li>-->
    <!--                          <span class="dropdown-item" @click="showComponent('trivia')"-->
    <!--                          >Trivia/Quiz</span-->
    <!--                          >-->
    <!--            </li>-->
          </ul>
        </div>

        <span>
         <i class="fas fa-stopwatch"></i>
        Timeline</span>
      </div>
    </div>
    <div class="card-body p-2">
      <div class="timeline-wrapper">
        <div id="timeline-div">
          <newTimeLine />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Editor from '../../../../external_libs/frame.js/editor/js/Editor'
import newTimeLine from './newTimeLine'
import models from './timeline-components/models'
import character from './timeline-components/character'
import Video from './timeline-components/video.vue'
import sounds from './timeline-components/sounds'
import effect from './timeline-components/effect'
import mediaImages from './timeline-components/mediaImages.vue'
import light from './timeline-components/light.vue'

export default {
  components: {
    newTimeLine,
    models,
    character,
    sounds,
    mediaImages,
    effect,
    Video,
    light
  },
  data () {
    return {
      timelineId: '',
      editor: new Editor(),
    }
  },
  created () {
  },
  created() {},
  methods: {

    activePopup(id){
      this.$store.state.sceneElementCurrentPopup = id
    },
    showComponent (type, nodeElementIndex) {
      // this.$root.$emit('trigger', nodeElementIndex)
      // this.$store.dispatch('saveNodeElementIndex', nodeElementIndex)
      this.$emit('openComponent', type)
    }
  },
  mounted () {
    this.$root.$on('showInspector', type => {
      switch (type) {
          case 'video':
            this.showComponent('videosinspector', 3)
            break;
          case 'character':
            this.showComponent('characterinspector', 2)
            break;
          case 'object3d':
            this.showComponent('modelsinspector', 1)
            break;
          case 'light':
            this.showComponent('lightsinspector', 0)
            break;
          case 'sound':
            this.showComponent('soundinspector', 4)
            break;
          case 'image':
            this.showComponent('imagesinspector', 5)
            break;
          case 'effect':
            this.showComponent('effectsinspector', 6)
            break;
          default:
            // _this.$root.$emit('showInspector', 2)
            console.log('error')
        }
      
      // console.log(id)
    })
    // TODO: needs to be edited based off what the selected story nodes (characters or 3D Objects...)(use the storyID from localstorage or store)
    // 
    // let timeline = new Timeline(this.editor)
    // document.getElementById('timeline-div').appendChild(timeline.dom)
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
  .AddScene {
    background-color: #262626;
    height: 100%;
    width: 100%;
    border-radius: 5px;

    i {
      margin-right: 5px;
    }

    &:hover {
      background-color: #303030;
    }
  }
  #modalContainer{
    position: fixed;
    top: 50%;
    left: 52%;
    z-index: 10000;
    width: 93vw;
    overflow: auto;
    height: 80vh;
    transform: translate(-50%, -50%);
    padding: 2em;
    z-index: 10;
    #closePopup{
      position: absolute;
      right: 50px;
      top: 50px;
      color: #47b784;
      border-radius: 50%;
      border: 1px solid #cccccc81;
      z-index: 4;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    #customModal{
    position: relative;
    top: 0;
    left: 0;
    z-index: 3;
    padding: 2em 3em 3em;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: #262626;
    border: 1px solid #cccccc81;
    border-radius: 5px;
    overflow: auto;

    #selectorContainer{
      height: 100px;
      button{
        padding: 0.5em 1em;
        border: 1px solid #cccccc81;
        border-radius: 5px;
        &.active{
          background-color: #47b784;
        }
      }
    }
    >div{
      width: 100%;
      height: 100%;
    }
  }
  
  }
  #mask{
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-color: #00000081;
    z-index: 2;
  }
</style>


// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline.vue